var markdown = function (markdownService) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            element.innerHTML = markdownService.translate(element.innerHTML);
        }
    }
}

markdown.$inject = ['markdownService'];

export default markdown;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/directives/markdown.directive.js